import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { sentryLog } from '../Utils/SentryLog';
/* global gtag */

function SlidesFooterComponent({setShowFeedbackPopup, forSlidesExtension, forSheetsExtension, fromSheetsExtensionHomePage}){

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();

    isShowConsole && console.log("Current Path:", location.pathname); 
    
    const handleFeedback = e => {
        //event tracker
            gtag('event', 'feedback_clicked', {
                event_category: 'Button',
                event_label: 'Feedback'
            });
        //
        try{
          isShowConsole && console.log('feedback button clicked');
          setShowFeedbackPopup(true);
        }catch(err){
          isShowConsole && console.log('error in handleFeedback method: ', err);
          sentryLog(`SlidesFooterComponent.js - handleFeedback failed: ${err?.message || err}`);
        }
    }

    let tosLink = "/slides-extension-terms-of-service";
    let ppLink = "/slides-extension-privacy-policy";
    let contactUsLink = "/slides-extension-contact-us";

    return(
        <>
            <div className={`footerComponent ${fromSheetsExtensionHomePage ? 'sheetsHome' : ''}`}>
                <div className='footer'>
                    <div className='containerDiv'>
                        <div className={`${location.pathname === tosLink ? 'selected' : ''}`}><Link to={tosLink}><span>Terms & Conditions</span></Link></div>
                        <div className={`${location.pathname === ppLink ? 'selected' : ''}`}><Link to={ppLink}><span>Privacy Policy</span></Link></div>
                        {/* <div className={`${location.pathname === '/refund-policy' ? 'selected' : ''}`}><Link to="/refund-policy"><span>Refund Policy</span></Link></div> */}
                        <div className={`${location.pathname === contactUsLink ? 'selected' : ''}`}><Link to={contactUsLink}><span>Contact Us</span></Link></div>
                        {/* {forSheetsExtension && <div className={`${location.pathname === '/sheets-extension-faq' ? 'selected' : ''}`}><Link to="/sheets-extension-faq"><span>FAQ</span></Link></div>} */}
                    </div>
                    {!fromSheetsExtensionHomePage && 
                        <div className='feedbackBtn' onClick={handleFeedback}>
                            Feedback ?
                        </div>
                    }
                </div>
                <div className='copyRightDiv'>
                    Copyright © 2026 &nbsp;|&nbsp; Made with ❤️ by easyimagetotext.com &nbsp;|&nbsp; All rights reserved
                </div>
            </div>
            <div className='mobileFooterComponent'>
                <div className='footer'>
                    <div className='containerDiv'>
                        <div className={`${location.pathname === '/terms-of-service' ? 'selected' : ''}`}><Link to={tosLink}><span>Terms & Conditions</span></Link></div>
                        <div className={`${location.pathname === '/privacy-policy' ? 'selected' : ''}`}><Link to={ppLink}><span>Privacy Policy</span></Link></div>
                        {/* <div className={`${location.pathname === '/refund-policy' ? 'selected' : ''}`}><Link to="/refund-policy"><span>Refund Policy</span></Link></div> */}
                        <div className={`${location.pathname === '/contact-us' ? 'selected' : ''}`}><Link to={contactUsLink}><span>Contact Us</span></Link></div>
                        {/* {forSheetsExtension && <div className={`${location.pathname === '/sheets-extension-faq' ? 'selected' : ''}`}><Link to="/sheets-extension-faq"><span>FAQ</span></Link></div>} */}
                    </div>
                    {!fromSheetsExtensionHomePage && 
                        <div className='feedbackBtn' onClick={handleFeedback}>
                            Feedback ?
                        </div>
                    }
                </div>
                <div className='copyRightDiv'>
                    Copyright © 2026 &nbsp;|&nbsp; Made with ❤️ by easyimagetotext.com &nbsp;|&nbsp; All rights reserved
                </div>
            </div>
        </>
    )
}

export default SlidesFooterComponent;